import styled from 'styled-components';

import { useDynamicContentContext } from '../../../contexts';
import { useContentController } from '../../../hooks/form';
import { useTranslation } from '../../../hooks/useTranslation';
import { ContentType } from '../../../types';
import { CustomTextButton } from './CustomTextButton';
import { ImagePickerButton } from './ImagePickerButton';
import { SnippetPickerButton } from './SnippetPickerButton';

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 10px;
  grid-area: center;
  align-items: center;
`;

const Prompt = styled.div`
  color: ${({ theme }) => theme.colors.textColors.textSecondary};
  grid-area: left;
  text-align: right;
`;

const Suffix = styled.div`
  color: ${({ theme }) => theme.colors.textColors.textSecondary};
`;

export const Placeholder = () => {
  const {
    field: { onChange },
  } = useContentController();
  const { t } = useTranslation();
  const { contentType } = useDynamicContentContext();

  const canInsertImage = contentType === ContentType.html;
  const onSelectContent = (content: string) => onChange({ target: { value: content } });

  return (
    <>
      <Prompt>{t('contentPicker.prompt')}</Prompt>
      <Wrapper data-test="placeholder">
        {canInsertImage && <ImagePickerButton onSelectContent={onSelectContent} />}
        <CustomTextButton onSelectContent={onSelectContent} />
        <SnippetPickerButton onSelectContent={onSelectContent} />
        <Suffix>{t('contentPicker.suffix')}</Suffix>
      </Wrapper>
    </>
  );
};
